<template>
  <div class="data_brain_wrap">
    <el-row class="card_wrap" type="flex">
      <div
        style="
          display: flex;
          width: 100%;
          height: 100%;
          align-items: center;
          justify-content: center;
        ">
        <!-- <div class="ggw">
          <div
            style="
              height: 100%;
              width: 100%;
              background: linear-gradient(to bottom, #030169, #2525bc);
              border-radius: 100px;
              display: flex;
              justify-content: center;
              align-items: center;
              flex-direction: column;
            ">
            <div style="font-size: 2ch; font-weight: 700; color: #fff">
              在线
            </div>
            <div style="font-size: 2ch; font-weight: 700; color: #fff">
              客服
            </div>
          </div>
        </div> -->
        <div
          style="
            width: 100%;
            height: 100%;
            background-color: #fff;
            position: relative;
            margin-right: 2vw;
          ">
          <div class="fenlei">
            <div
              v-for="(item, index) in articleType"
              :key="index"
              class="fenleilist"
              :class="['item', index === currentTab ? 'active' : '']"
              @click.stop="wzxslist(item, index)">
              {{ item.name }}
            </div>
          </div>
          <div class="page-content">
            <!-- <div class="fenlei">
              <div
                v-for="(item, index) in articleType"
                :key="index"
                class="fenleilist">
                {{ item.name }}
              </div>
            </div> -->
            <div
              style="
                display: flex;
                justify-content: space-between;
                align-items: center;
              ">
              <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">
                  首页
                </el-breadcrumb-item>
                <el-breadcrumb-item>行业要闻</el-breadcrumb-item>
              </el-breadcrumb>
              <div>
                <el-input
                  placeholder="请输入内容"
                  suffix-icon="el-icon-search"
                  v-model="input"
                  @change="searchlist"></el-input>
              </div>
            </div>

            <div style="padding: 12px; display: flex; flex-direction: column">
              <div
                v-for="(item, index) in articleList"
                :key="index"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  padding: 6px 0;
                  border-bottom: 1px solid #eaeaea;
                  height: 7vw;
                  cursor: pointer;
                "
                @click.stop="towzlist(item)">
                <div
                  style="
                    width: 80%;
                    height: 100%;
                    overflow: hidden;
                    display: flex;
                    flex-direction: column;
                  ">
                  <div style="position: relative">
                    <div style="font-size: 2ch; font-weight: 600">
                      {{ item.name }}
                    </div>
                  </div>

                  <div style="font-size: 1.8ch">
                    {{ item.createtime.split(' ')[0] }}
                  </div>
                  <!-- <div v-html="item.content" style="overflow: hidden;"></div> -->
                  <div
                    style=" font-size: 1.8ch; overflow: hidden;display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 2;"
                    class="wzlistinfo">
                    {{ item.subname }}
                  </div>
                  <!-- <div
                    style="height: 2.4vw; font-size: 1.8ch; overflow: hidden;"
                    class="wzlistinfo">
                    {{ item.subname }}
                  </div> -->
                </div>
                <div style="height: 4vw; width: 15%">
                  <img
                    :src="item.pic"
                    alt=""
                    style="width: 100%; height: 100%" />
                </div>
              </div>
            </div>
          </div>
          <div
            style="
              position: absolute;
              bottom: 10px;
              display: flex;
              width: 100%;
              justify-content: center;
            ">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="currentPage"
              :page-size="pageSize"
              :total="total"
              layout="total, prev, pager, next, jumper"
              background></el-pagination>
          </div>
        </div>
        <div class="card" style="width:29%;height:100%;">
          <memberCenter style="height:20%;"></memberCenter>
          <div
            style="
              width: 100%;
              height: 8%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            ">
            <!-- <div
              style="
                width: 100%;
                height: 48%;
                background-color: #fff;
                text-align: center;
              ">
              会员福利
            </div>
            <div
              style="
                width: 100%;
                height: 48%;
                background-color: #fff;
                text-align: center;
              ">
              企业入驻
            </div> -->
            <div style="height: 46%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item, index) in ad1" :key="index">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item.link">
                    <img
                      :src="item.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 46%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item2, index2) in ad2" :key="index2">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item2.link">
                    <img
                      :src="item2.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div
            style="
              width: 100%;
              height: 6%;
              display: flex;
              justify-content: space-between;
            ">
            <!--   <div
              style="
                width: 48%;
                height: 100%;
                text-align: center;
                background-color: #fff;
              ">
              图片
            </div>
            <div
              style="
                width: 48%;
                height: 100%;
                text-align: center;
                background-color: #fff;
              ">
              图片
            </div> -->
            <div style="height: 100%; width: 48%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item3, index3) in ad3" :key="index3">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item3.link">
                    <img
                      :src="item3.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 100%; width: 48%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item4, index4) in ad4" :key="index4">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item4.link">
                    <img
                      :src="item4.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <div class="newslist">
            <div
              v-for="(item, index) in indexArticle"
              :key="index"
              style="padding: 0.6vw; border-bottom: 1px solid #c3c3c3">
              {{ item.name }}
            </div>
          </div>
          <div
            style="
              width: 100%;
              height: 28%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            ">
            <div style="height: 15%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item5, index5) in ad5" :key="index5">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item5.link">
                    <img
                      :src="item5.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 15%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item6, index6) in ad6" :key="index6">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item6.link">
                    <img
                      :src="item6.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 15%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item7, index7) in ad7" :key="index7">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item7.link">
                    <img
                      :src="item7.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 15%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item8, index8) in ad8" :key="index8">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item8.link">
                    <img
                      :src="item8.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 15%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item v-for="(item9, index9) in ad9" :key="index9">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item9.link">
                    <img
                      :src="item9.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div style="height: 15%; width: 100%">
              <el-carousel indicator-position="none">
                <el-carousel-item
                  v-for="(item10, index10) in ad10"
                  :key="index10">
                  <!-- <h3 class="small">{{ item }}</h3> -->
                  <a :href="item10.link">
                    <img
                      :src="item10.pic"
                      alt=""
                      style="width: 100%; height: 100%" />
                  </a>
                </el-carousel-item>
              </el-carousel>
            </div>
            <!-- <div class="block">
              <el-carousel height="5vw" indicator-position="none">
                <el-carousel-item
                  v-for="item in 4"
                  :key="item"
                  style="background-color: #fff">
                  广告位
                </el-carousel-item>
              </el-carousel>
            </div> -->
          </div>
          <div
            style="
              width: 100%;
              height: 20%;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
              overflow: hidden;
            ">
            <div
              style="
                height: 10%;
                width: 100%;
                font-size: 2.6ch;
                font-weight: 700;
                color: #030169;
                display: flex;
                align-items: center;
                border-top: 2px solid #030169;
              ">
              最新文章
            </div>
            <div class="newNews">
              <div
                v-for="(item, index) in indexArticle"
                :key="index"
                style="
                  padding: 0.6vw;
                  border-bottom: 1px solid #c3c3c3;
                  font-size: 1.8ch;
                ">
                <span style="margin-right: 0.2vw">
                  {{ item.createtime.split(' ')[0] }}
                </span>
                <span>
                  {{ item.name }}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import {
  getArticle,
  AdList,
} from "@/api/user.js";
import memberCenter from "@/components/memberCenter/memberCenter.vue";
let settoken = null;
export default {
  components:{memberCenter},
  data() {
    return {
      currentPage: 1,
      pageSize: 15, // 每页显示的卡片数量
      // 所有数据
      allData: [],
      articleType: [],
      content: "",
      cid: 44,
      ad1: [],
      ad2: [],
      ad3: [],
      ad4: [],
      ad5: [],
      ad6: [],
      ad7: [],
      ad8: [],
      ad9: [],
      ad10: [],
      input: "",
      currentTab: -1,
      keyword: "",
      pagenum: 1,
      indexArticle:[],
      articleList :[],
      total:0,
    };
  },
  computed: {
    // total() {
    //   return this.allData.length;
    // },
    // // 计算当前页面要显示的数据
    // currentPageContent() {
    //   const start = (this.currentPage - 1) * this.pageSize;
    //   const end = start + this.pageSize;
    //   return this.allData.slice(start, end);
    // },
  },
  created() {
    this.getdata();
  },
  methods: {
    searchlist() {
      console.log(this.input);
      this.keyword = this.input;
      this.getdata();
    },
    wzxslist(item, index) {
      this.currentTab = index;
      this.cid = item.id;
      this.getdata();
    },

    getdata() {
      const that = this;

      // getArticle({
      //   cid: that.cid,
      //   keyword: that.keyword,
      //   pagenum: that.pagenum,
      // }).then((res) => {
      //   console.log("文章列表", res);
      //   that.allData = res.data;
      //   that.articleType = res.clist;
      // });

      // that.allData = [];
      // (async () => {
      //   while (true) {
      //     try {
      //       const res = await getArticle({
      //         cid: that.cid,
      //         keyword: that.keyword,
      //         pagenum: that.pagenum,
      //       });
      //       console.log("文章列表", res);
      //       if (res.data.length === 0) {
      //         break;
      //       }
      //       that.allData = that.allData.concat(res.data);
      //       that.articleType = res.clist;
      //       that.pagenum++;
      //     } catch (error) {
      //       console.error("请求出错:", error);
      //       break;
      //     }
      //   }
      // })();
      this.getArticleList();
      AdList(
          ['INDUSTRY-AD-1','INDUSTRY-AD-2','INDUSTRY-AD-3','INDUSTRY-AD-4','INDUSTRY-AD-5','INDUSTRY-AD-6','INDUSTRY-AD-7','INDUSTRY-AD-8','INDUSTRY-AD-9','INDUSTRY-AD-10']
        ).then((res) => {
        console.log('resres',res);
        that.ad1 = res.data['INDUSTRY-AD-1'].data?JSON.parse(res.data['INDUSTRY-AD-1'].data):[];
        that.ad2 = res.data['INDUSTRY-AD-2'].data?JSON.parse(res.data['INDUSTRY-AD-2'].data):[];
        that.ad3 = res.data['INDUSTRY-AD-3'].data?JSON.parse(res.data['INDUSTRY-AD-3'].data):[];
        that.ad4 = res.data['INDUSTRY-AD-4'].data?JSON.parse(res.data['INDUSTRY-AD-4'].data):[];
        that.ad5 = res.data['INDUSTRY-AD-5'].data?JSON.parse(res.data['INDUSTRY-AD-5'].data):[];
        that.ad6 = res.data['INDUSTRY-AD-6'].data?JSON.parse(res.data['INDUSTRY-AD-6'].data):[];
        that.ad7 = res.data['INDUSTRY-AD-7'].data?JSON.parse(res.data['INDUSTRY-AD-7'].data):[];
        that.ad8 = res.data['INDUSTRY-AD-8'].data?JSON.parse(res.data['INDUSTRY-AD-8'].data):[];
        that.ad9 = res.data['INDUSTRY-AD-9'].data?JSON.parse(res.data['INDUSTRY-AD-9'].data):[];
        that.ad10 = res.data['INDUSTRY-AD-10'].data?JSON.parse(res.data['INDUSTRY-AD-10'].data):[];
      });
    },
    getArticleList(){
      let param = {
        page: this.currentPage,
        limit: this.pageSize,
        search: {
            keyWord: this.keyword,
            cid: this.cid
        }
      }
      getArticle(param).then((res) => {
        console.log("res", res);
        if(this.currentPage==1){
          this.indexArticle = res.data;
        }
        this.articleList = res.data;
        this.total = res.count;
      });
    },
    // 处理每页显示条目数变化
    handleSizeChange(newSize) {
      this.pageSize = newSize;
      this.currentPage = 1;
      this.getArticleList();
    },
    // 处理当前页码变化
    handleCurrentChange(newPage) {
      this.currentPage = newPage;
      this.getArticleList();
    },
    handleNavigate() {
      this.$router.push("/production/1").catch((v) => {});
    },
    // tologin() {
    //   this.$router.push({ name: "login" });
    // },
    towzlist(item) {
      this.$router.push({
        path: "/wzdetail",
        query: {
          id: item.id, // 你想要传递的 id
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.data_brain_wrap {
  padding: 70px 0;
  background: #e8eef2;
  .fenlei {
    width: 100%;
    padding: 20px 10px;
    display: flex;
    overflow-x: scroll;
    display: none;
    .fenleilist {
      height: 3vw;
      // width: 6vw;
      flex: 0 0 7vw;
      text-align: center;
      line-height: 3vw;
      background: linear-gradient(to right, #f7faff, #a8c7ff);
      color: #111;
      border-radius: 5px;
      cursor: pointer;
      margin-right: 1vw;
    }
    .fenleilist.active {
      height: 3vw;
      // width: 6vw;
      flex: 0 0 7vw;
      text-align: center;
      line-height: 3vw;
      background: linear-gradient(to right, #792ee7, #04c0cd);
      color: #fff;
      border-radius: 5px;
      cursor: pointer;
      margin-right: 1vw;
    }
  }
  // text-align: center;
  .brain_title {
    color: #203040;
    font-size: 40px;
    font-weight: bold;
    padding: 30px 0;
    @media screen and (max-width: 768px) {
      font-size: 1.5rem;
    }
  }
  .brain_desc {
    color: rgba(32, 48, 64, 0.75);
    font-size: 22px;
    letter-spacing: 4px;
    @media screen and (max-width: 768px) {
      font-size: 0.8rem;
      line-height: 40px;
    }
  }

  .card_wrap {
    width: 80%;
    flex-wrap: wrap;
    margin: 0px auto;
    justify-content: space-between;
    height: 2400px;
    border-radius: 8px;
    position: relative;
    @media screen and (max-width: 768px) {
      width: 95%;
    }
    .card {
      width: 22%;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      ::v-deep .el-carousel {
        height: 100%;

        .el-carousel__container {
          height: 100%;
        }
      }
      .cardInfo {
        padding: 1vw;
        width: 100%;
        height: 20%;
        background: linear-gradient(to bottom right, #ffffff, #94c0fe);
        display: flex;
        flex-direction: column;
        align-items: center;
        .cardTop {
          display: flex;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
        }
        .cardBody {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 1vw;
          width: 100%;
          .fabu {
            display: flex;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
          }
        }
        .vipbtn {
          margin-bottom: 0.5vw;
          display: flex;
          justify-content: space-between;
          width: 100%;
          align-items: center;
          background: linear-gradient(to top, #1e037c, #2520ab);
          padding: 0.5vw;
          cursor: pointer;
          border-top-right-radius: 0.3vw;
          border-top-left-radius: 0.3vw;
        }
        .cardBottom {
          margin-bottom: 1vw;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
          width: 100%;
          .cardlist {
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 30%;
            margin-bottom: 1vw;
          }
        }
        .loginout {
          width: 60%;
          height: 2vw;
          background-color: #f3f5f4;
          text-align: center;
          line-height: 2vw;
          font-size: 2ch;
          font-weight: 600;
          color: #b0b3b7;
          border-radius: 2%;
          cursor: pointer;
        }
      }
      .newslist {
        width: 100%;
        height: 14%;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
      .newNews {
        width: 100%;
        height: 88%;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .page-content {
      width: 100%;
      height: 100%;
      padding: 10px 5px 5px 5px;
      .wzlistinfo {
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .ggw {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 10%;
      width: 4%;
      margin-right: 1%;
    }
    .top-left {
      height: 100%;
      width: 20%;
      background-color: #0d067e;
      display: flex;
      flex-direction: column;
      border-radius: 6px;
      .top-left-title {
        width: 100%;
        height: 50px;
        display: flex;
        align-items: center;
        color: #fff;
        padding: 10px 20px;
        font-weight: 700;
        font-size: 16px;
      }
      .top-left-info {
        width: 100%;
        flex: 1;
        border-top-right-radius: 6px;
        border-top-left-radius: 6px;
        background-color: #fff;
        padding: 30px 20px;
        overflow-y: scroll;
        -ms-overflow-style: none; /* IE 和 Edge */
        scrollbar-width: none; /* Firefox */
      }
      .scrollable-container::-webkit-scrollbar {
        display: none; /* 隐藏滚动条 */
      }
    }
    .top-center {
      height: 100%;
      width: 50%;
      background-color: #fff;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .el-carousel__item h3 {
        color: #475669;
        font-size: 14px;
        opacity: 0.75;
        line-height: 300px;
        margin: 0;
      }

      .el-carousel__item:nth-child(2n) {
        background-color: #99a9bf;
      }

      .el-carousel__item:nth-child(2n + 1) {
        background-color: #d3dce6;
      }
    }
    .brain_item {
      transition: background-color 1s;
      padding: 30px;
      @media screen and (max-width: 768px) {
        font-size: 0.8rem;
        line-height: 40px;
        border-radius: 10px;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 20px;
        &:nth-child(-n + 2) {
          margin-top: 0;
        }
      }
      background: #fff;
      border-radius: 20px;
      box-shadow: 0 0.5rem 1.5rem 0 rgba(0, 135, 168, 0.15);
      margin-top: 40px;
      position: relative;
      .item_bg {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          134deg,
          #0649b8 1%,
          #0a7fd7 41%,
          #03d2c5 99%
        );
        opacity: 0;
        transition: all 0.5s;
        border-radius: 20px;
        z-index: 1;
      }
      &:hover .item_bg {
        opacity: 1;
      }
      &:hover .item_title {
        color: #fff;
      }
      &:hover .item_desc {
        color: #fff;
      }
      .item_title {
        transition: all 0.5s;
        font-size: 30px;
        font-weight: bold;
        color: #203040;
        text-align: left;
        padding: 20px 0 40px 0;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          font-size: 1rem;
          text-align: center;
        }
      }
      .item_desc {
        transition: all 0.5s;
        color: #666;
        text-align: left;
        line-height: 1.5rem;
        z-index: 2;
        position: inherit;
        font-size: 18px;
        min-height: 110px;
        @media screen and (max-width: 768px) {
          min-height: 110px;
          text-indent: 2em;
          font-size: 12px;
        }
      }
      .item_navigate {
        width: 100px;
        height: 30px;
        padding: 0 10px;
        background: #ffa400;
        color: #fff;
        border-radius: 20px;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        margin-top: 40px;
        cursor: pointer;
        z-index: 2;
        position: inherit;
        @media screen and (max-width: 768px) {
          margin-bottom: 10px;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
